
import { AxiosRequestConfig } from 'axios';
import { CommonAxiosServiceWp }  from './common-axios-service-wp';
import { CompanyIdRequest, CompanyModel, CompanyResponse, GlobalResponseObject, RoleContactId, RoleContactResponse, RoleContactsModel, RoleIdRequest, RoleModel, RolesResponse } from '@schemax-whatsapp/shared-models';

export class RoleService extends CommonAxiosServiceWp {
    private getURLwithMainEndPoint(childUrl: string) {
        return '/role/' + childUrl;
    }

    async createRole( request: RoleModel, config?: AxiosRequestConfig): Promise<RolesResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('createRole'), request, config);
    }

    async editRole( request: RoleModel, config?: AxiosRequestConfig): Promise<RolesResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('editRole'), request, config);
    }

    async getAllRolesForCompanyId( companyIdReq: CompanyIdRequest,config?: AxiosRequestConfig): Promise<RolesResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getAllRolesForCompanyId'), companyIdReq, config);
    }

    async deleteRole( roleReq: RoleIdRequest, config?: AxiosRequestConfig): Promise<RolesResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('deleteRole'), roleReq, config);
    }

    async createRoleContact( request: RoleContactsModel, config?: AxiosRequestConfig): Promise<RoleContactResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('createRoleContact'), request, config);
    }

    async getRoleContactsForRoleId( request: RoleIdRequest, config?: AxiosRequestConfig): Promise<RoleContactResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getRoleContactsForRoleId'), request, config);
    }

    async getRoleContactsForCompanyId( request: CompanyIdRequest, config?: AxiosRequestConfig): Promise<RoleContactResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getRoleContactsForCompanyId'), request, config);
    }


    async deleteRoleContact( roleReq: RoleContactId, config?: AxiosRequestConfig): Promise<RoleContactResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('deleteRoleContact'), roleReq, config);
    }

}